<template>
  <v-btn
    small
    title="Print/Export to PDF this data"
    class="action-btn"
    :icon="icon"
    :outlined="!icon"
    v-bind="$attrs"
    v-on="$listeners"
    @click="print"
  >
    <v-icon small>fas fa-print</v-icon>
    <span v-if="!icon" class="ml-2">Print</span>
  </v-btn>
</template>

<script>
import usePrinting from "../usePrinting";

export default {
  name: "ButtonPrint",
  props: {
    icon: {
      type: Boolean,
      default: true,
    },
    beforePrint: {
      validator: (val) => typeof val === "function",
      default: null,
    },
    afterPrint: {
      validator: (val) => typeof val === "function",
      default: null,
    },
    triggerShowAll: {
      validator: (val) => typeof val === "function",
      default: null,
    },
    waitForData: {
      validator: (val) => typeof val === "function",
      default: null,
    },
  },
  setup() {
    const { setPrinting } = usePrinting();
    return { setPrinting };
  },
  data() {
    return {
      isPreparingPrint: false,
    };
  },
  methods: {
    async print() {
      this.isPreparingPrint = true;

      try {
        // Always trigger show all and wait for data if available
        if (this.triggerShowAll && this.waitForData) {
          await this.triggerShowAll();
          await this.waitForData();
        } else if (this.beforePrint) {
          await this.beforePrint();
        }

        this.setPrinting(true);
        await this.$nextTick();

        setTimeout(() => {
          const allTableFooters = document.querySelectorAll(
            ".v-data-table .v-data-footer"
          );
          allTableFooters.forEach((el) => {
            el.classList.add("action-btn");
          });

          window.print();

          allTableFooters.forEach((el) => el.classList.remove("action-btn"));

          if (this.afterPrint) {
            this.afterPrint();
          }

          this.setPrinting(false);
          this.isPreparingPrint = false;
        }, 100);
      } catch (error) {
        console.error("ButtonPrint: Error preparing print:", error);
        this.isPreparingPrint = false;
        this.setPrinting(false);
        if (this.afterPrint) {
          this.afterPrint();
        }
      }
    },
  },
};
</script>
